import Badge01 from "./badge-01";
import BadgeAlert from "./badge-alert";
import BadgeCent from "./badge-cent";
import BadgeCheck from "./badge-check";
import BadgeCheck01 from "./badge-check-01";
import BadgeCheck02 from "./badge-check-02";
import BadgeCheck03 from "./badge-check-03";
import BadgeCheck04 from "./badge-check-04";
import BadgeDollarSign from "./badge-dollar-sign";
import BadgeEuro from "./badge-euro";
import BadgeHelp from "./badge-help";
import BadgeIndianRupee from "./badge-indian-rupee";
import BadgeInfo from "./badge-info";
import BadgeJapaneseYen from "./badge-japanese-yen";
import BadgeMinus from "./badge-minus";
import BadgePercent from "./badge-percent";
import BadgePlus from "./badge-plus";
import BadgePoundSterling from "./badge-pound-sterling";
import BadgeRussianRuble from "./badge-russian-ruble";
import BadgeSwissFranc from "./badge-swiss-franc";
import BadgeX from "./badge-x";

export * from "./badge-01";
export * from "./badge-alert";
export * from "./badge-cent";
export * from "./badge-check";
export * from "./badge-dollar-sign";
export * from "./badge-euro";
export * from "./badge-help";
export * from "./badge-indian-rupee";
export * from "./badge-info";
export * from "./badge-japanese-yen";
export * from "./badge-minus";
export * from "./badge-plus";
export * from "./badge-x";
export * from "./badge-percent";
export * from "./badge-pound-sterling";
export * from "./badge-russian-ruble";
export * from "./badge-swiss-franc";
export * from "./badge-check-01";
export * from "./badge-check-02";
export * from "./badge-check-03";
export * from "./badge-check-04";

export const Badge = {
  Badge01,
  BadgeAlert,
  BadgeCent,
  BadgeCheck,
  BadgeDollarSign,
  BadgeEuro,
  BadgeHelp,
  BadgeIndianRupee,
  BadgeInfo,
  BadgeJapaneseYen,
  BadgeMinus,
  BadgePlus,
  BadgeX,
  BadgePercent,
  BadgePoundSterling,
  BadgeRussianRuble,
  BadgeSwissFranc,
  BadgeCheck01,
  BadgeCheck02,
  BadgeCheck03,
  BadgeCheck04,
};
